import React from "react";

export const WhatsappButton = ({ data }) => {
  const contact = data || {};
  const number = (contact.whatsapp || contact.phone || "").replace(/[^0-9]/g, "");

  if (!number) return null;

  const message = encodeURIComponent(
    "Hello International Rocks — I would like a quotation. Material:  / Finish:  / Thickness:  / Quantity:  / Delivery to: "
  );

  return (
    <a
      className="whatsapp-float"
      href={`https://wa.me/${number}?text=${message}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
    >
      <i className="fa fa-whatsapp"></i>
      <span className="whatsapp-float-label">Chat on WhatsApp</span>
    </a>
  );
};
